import React from "react";
import { RouteComponentProps } from "react-router-dom";
import Store from "../../state/store";
import Actions from "../../state/actions";
import { inject, observer } from "mobx-react";
import { SectionResources } from "../../types";
import { findItemAndIndexById } from "../../utils";
import { ResourcePageContainer } from "./Resource.style";

interface Props extends RouteComponentProps {
  store?: Store;
  mutator?: Actions;
  idSection: string;
}

const ResourcePage: React.FC<Props> = (props) => {
  const sectionItemAndIndex = findItemAndIndexById(props.idSection, props.store!.content.sections);
  const section = sectionItemAndIndex.item as SectionResources;
  return (
    <ResourcePageContainer>
      <h1>{section.title}</h1>
      {section.resources.map((res) => (
        <a key={res.id} href={res.url} target="_blank">
          {res.title}
        </a>
      ))}
    </ResourcePageContainer>
  );
};

export default inject("store", "mutator")(observer(ResourcePage));
